<template>
<div class="chapter">
<div class="inner_page">
<p class="copy1">Publisher: Amy Marson</p>
<p class="copy">Creative Director: Gailen Runge</p>
<p class="copy">Acquisitions Editor: Roxane Cerda</p>
<p class="copy">Managing Editor: Liz Aneloski</p>
<p class="copy">Editor: Katie Van Amburg</p>
<p class="copy">Technical Editor: Helen Frost</p>
<p class="copy">Cover/Book Designer: April Mostek</p>
<p class="copy">Production Coordinator: Tim Manibusan</p>
<p class="copy">Production Editor: Jennifer Warren</p>
<p class="copy">Illustrator: Mary E. Flynn</p>
<p class="copy">Photo Assistants: Mai Yong Vang and Rachel Holmes</p>
<p class="copy">Cover photography by Mai Yong Vang of C&amp;T Publishing, Inc.</p>
<p class="copy">Quilt photography by Mai Yong Vang and subject photography by Kelly Burgoyne of C&amp;T Publishing, Inc.</p>
<p class="copy2">Published by C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Copyright.vue?288ae3b2